import { createFileRoute } from '@tanstack/react-router';

import { requireOnboardingStage } from '../../features/onboarding/require-onboarding-stage';
import { ReviewPanel } from '../../features/onboarding/review-panel';

export const Route = createFileRoute('/onboarding/review')({
  beforeLoad: ({ context, location }) =>
    requireOnboardingStage({
      queryClient: context.queryClient,
      location,
      path: '/onboarding/review',
    }),
  component: ReviewPanel,
});
